import { OperationCanceledException } from '../modules/tcm-core.module';

export class Task {
    public static delay(ms: number, cancellation?: Promise<any>): Promise<any> {
        return new Promise((resolve, reject) => {

            const timeout = setTimeout(() => resolve(null), ms);

            if (cancellation) {
                cancellation.then(() => {
                    clearTimeout(timeout);
                    reject(new OperationCanceledException());
                });
            }
        });
    }

    // public static debounce<T extends Function>(ms: number, fn: T, cancellation?: Promise<any>): T {
    //     let timer;

    //     return function() {
    //         clearTimeout(timer);
    //         var args = Array.prototype.slice.call(arguments);
    //         args.unshift(this);
    //         timer = setTimeout(fn.bind.apply(fn, args), ms);
    //         if (cancellation) {
    //             cancellation.then(() => {
    //                 clearTimeout(timer);
    //             });
    //         }
    //     } as any;
    // }
}
